/************************************
MODULE:         Map module
WHAT IT DOES:   Uploads google maps script sends map modules to initialization with all the parametrs
*************************************/
(function(root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        root.returnExports = factory(root.jQuery);
    }
})(this, function($) {
    var isScriptLoaded = false;
    var isMapLoaded = false;
    var mapCallbacks = [];
    var key = '';
    var lang = '';
    var region = '';
    var isIntersectionObserverAvailable = ('IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype);

    function init() {
        var map = $('.js-map').not('.js-popup-map').not('js-inited');
        if (!map.length) return;

        key = map.data('key') || '';

        lang = map.data('lang') || '';
        region = map.data('region') || '';
        
        var googleMapsLoadDelay = window.appState.googleMapsLoadDelay;
        var delay = !isNaN(googleMapsLoadDelay) ? googleMapsLoadDelay : 0;
        
        setTimeout(function() {
            if (typeof window.gmapInitialize == 'undefined' || !isMapLoaded) {
                loadScript(initialize.bind(this));
            } else {
                initialize();
            }
        }, delay);   
        
    }

    function loadScript(callback) {
        mapCallbacks.push(callback);

        if (isScriptLoaded === true) {
            return;
        }

        isScriptLoaded = true;

        var mapscript = document.createElement('script');
        mapscript.type = 'text/javascript';
        mapscript.async = true;
        mapscript.src =
            'https://maps.googleapis.com/maps/api/js?v=3' +
            '&callback=gmapInitialize&key=' +
             key;
        if (lang !== '') {
            mapscript.src +='&language=' + lang;
        }

        if (region !== '') {
            mapscript.src +='&region=' + region;
        }

        document.body.appendChild(mapscript);
        window.gmapInitialize = onScriptLoaded;
    }

    function onScriptLoaded() {

        for (var i = 0, l = mapCallbacks.length; i < l; i++) {
            mapCallbacks[i]();
        }
        isMapLoaded = true;
    }

    function createGenericMapInstance($map, genericmap) {
        var settings = {};
        var dataAttributes = $map.data();

        for (var attr in dataAttributes) {
            settings[attr] = dataAttributes[attr];
        }

        new genericmap($map, settings);
        $map.addClass('js-inited');
    }

    function initialize() {
        if (typeof window.google == 'undefined') return;
        require.ensure([], function () {
            var map = $('.js-map').not('js-inited');
            var genericmap = require('generic.map');

            var observerOptions = {
                root: null,
                rootMargin: '200px',
                threshold: 0.01
            }

            var callback = function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        createGenericMapInstance($(entry.target), genericmap);
                        observer.unobserve(entry.target);
                    }
                })

            };

            if (isIntersectionObserverAvailable) {
                var observer = new IntersectionObserver(callback, observerOptions);
                for (var i = 0; i < map.length; i++) {
                    observer.observe(map[i]);
                }
            } else {
                for (var j = 0; j < map.length; j++) {
                    createGenericMapInstance(map.eq(j), genericmap);
                }
            }


        }, 'map');

    }

    return {
        init: init
    };
});



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.map.js
 ** module id = 44
 ** module chunks = 24
 **/